exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".inpirations-carousel .offer[data-v-232399e3]{height:100%}.inpirations-carousel .offer .offer-image[data-v-232399e3]{display:-ms-flexbox;display:flex;height:100%;width:100%;max-width:460px;max-height:460px;background-size:cover}@media (max-width: 767px){.inpirations-carousel .offer .offer-image[data-v-232399e3]{max-width:400px;max-height:400px}}\n", ""]);

// exports
